<template>
    <v-flex class="manage-videos-popup">
        <v-flex xs12 class="manage-videos-popup__header">
            <v-btn
                flat
                icon
                data-qe-id="manage_videos_btn"
                @click="closeFilesDialog()"
                class="close-btn">
                <v-icon>{{ManageVideosConstants.CLOSE}}</v-icon>
            </v-btn>
            <v-flex tag="h3"> {{ManageVideosConstants.CONTENT_EDITOR_PORTAL}}
                <v-flex class="welcome"> {{ManageVideosConstants.WELCOME_TO_CONNECT}}</v-flex>
            </v-flex>
        </v-flex>
        <span v-if="manageVideosError" class="error-msg"> {{ communityCommonConstant.filesAndMedia.FILENAME_ALREADY_EXISTS}} </span>
        <v-layout row wrap>
            <v-flex xs8 class="manage-videos-popup__breadcrumb">
                <span>
                    <i class="fas fa-home"></i>
                    <span class="content_header">{{ManageVideosConstants.CONTENT_EDITOR_PORTAL}}</span>
                </span>
            </v-flex>
            <v-flex xs4 class="manage-videos-popup__icons" v-if="isVisible">
                <div v-if="isReordered">
                    <v-btn class="primary_btn transparent small"
                           data-qe-id="manage-videos_cancel_order_btn"
                           @click="cancelOrder">{{appCommonConstants.CANCEL}}</v-btn>
                    <v-btn class="primary_btn small"
                           data-qe-id="manage-videos_save_order_btn"
                           @click="saveOrder">{{appCommonConstants.SAVE}}</v-btn>
                </div>
                <div v-if="!isReordered && isAddFolder">
                    <span class="share-link-copied-message"
                          v-if="shareLinkCopiedMessage.length">
                        {{shareLinkCopiedMessage}}
                    </span>
                    <v-icon class="fas fa-file-medical"
                            data-qe-id="manage-videos_add_new_file_btn"
                            :title="communityCommonConstant.filesAndMedia.ADD_FILE_TOOLTIP"
                            @click="displayFilesLayout()">
                    </v-icon>
                </div>
            </v-flex>
        </v-layout>
        <v-flex xs12 v-if="isShowFilesContainer">
            <upload-videos
                @closeDialog="closeFilesDragDropArea"
                :existing-file-names="takeTourVideoData.map(item => item.title)"
                :parentid="currentRoot === null ? null : currentRoot.id"
                :parentDirectory="this.currentRoot === null ? null : currentRoot.fileUrl"
                :fileTypesSupported="communityCommonConstant.filesAndMedia.FILETYPES_SUPPORTED"></upload-videos>
        </v-flex>
        <v-flex xs12>
            <v-layout row wrap class="headding hidden-xs">
                <v-flex xs1>
                    <a data-qe-id="manage-videos_order-by_type_btn"
                       @click="orderMediaBy(communityCommonConstant.filesAndMedia.tableColumns.TYPE.value,typeAsc)">
                        {{communityCommonConstant.filesAndMedia.tableColumns.TYPE.key}}
                    </a>
                </v-flex>
                <v-flex xs2 pl-2>
                    <a data-qe-id="manage-videos_order-by_name_btn"
                       @click="orderMediaBy(communityCommonConstant.filesAndMedia.tableColumns.NAME.value,nameAsc)">
                        {{communityCommonConstant.filesAndMedia.tableColumns.NAME.key}}
                        <span v-if="nameAsc" class="fas fa-sort-up"></span>
                        <span v-else class="fas fa-sort-down"></span>
                    </a>
                </v-flex>
                <v-flex xs3 pl-2>
                    <a data-qe-id="manage-videos_order-by_modified-by_btn"
                       @click="orderMediaBy(communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.value,modifiedByAsc)">
                        {{communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.key}}
                        <span v-if="modifiedByAsc" class="fas fa-sort-up"></span>
                        <span v-else class="fas fa-sort-down"></span>
                    </a>
                </v-flex>
                <v-flex xs6>
                    <a data-qe-id="manage-videos_order-by_last-modified_btn"
                       @click="orderMediaBy(communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.value,dateAsc)">
                        {{communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.key}}
                        <span v-if="dateAsc" class="fas fa-sort-up"></span>
                        <span v-else class="fas fa-sort-down"></span>
                    </a>
                </v-flex>
            </v-layout>
            <v-flex class="scroll-div">
                <draggable :list="takeTourVideoData" :options="{animation:200,disabled:(isRowEditingOrCreating), onSort:changeOrder()}" :move="onListItemMove">
                    <v-layout
                        row
                        wrap
                        v-for='(element,i) in takeTourVideoData'
                        :key="i"
                        v-bind:class="[(!canEditTakeTourVideos || isRowEditingOrCreating) ? 'dragDiv': 'dragDiv cursor-move']">
                        <v-flex xs2 sm1 class="typeBlock">
                            <v-icon large :class='iconClassNames(`mp4`)'> </v-icon>
                            <span v-if="!element.isDeleteRow"> {{getFileSize(element.isFolder, element.fileSize, element.id)}} </span>
                        </v-flex>
                        <v-flex xs10 sm11 v-if="element.isEditRow">
                            <v-layout row wrap>
                                <v-flex xs12 sm8 class="inputBlock">
                                    <input v-model="isEditName"
                                           maxlength="30"
                                           :data-qe-id="`tour_video_${i}_edit_name_text-area`"
                                           v-on:keypress="isValidFolderName($event,isEditName)"
                                           v-on:keyup="duplicateName(isEditName, appCommonConstants.UPDATE, element.fileSubType === communityCommonConstant.filesAndMedia.FOLDER)"/>
                                    <span v-if="isEditError"> {{isErrorMessage}} </span>
                                </v-flex>
                                <v-flex
                                    xs12
                                    sm5 md4
                                    text-xs-right
                                    class="btns_div">
                                    <v-btn class="primary_btn transparent small"
                                           :disabled="updateInProgress"
                                           :data-qe-id="`tour_video_${i}_edit_name_cancel_btn`"
                                           @click="cancelDetails(element)">
                                        {{appCommonConstants.CANCEL}}
                                    </v-btn>
                                    <v-btn
                                        class="primary_btn small"
                                        :loading="updateInProgress"
                                        @click="updateDetails(element)"
                                        :data-qe-id="`tour_video_${i}_edit_name_save_btn`"
                                        :disabled="isEditError">
                                        {{appCommonConstants.UPDATE}}
                                    </v-btn>
                                    <v-btn class="primary_btn transparent small pa-1"
                                           :data-qe-id="`tour_video_${i}_delete_btn`"
                                           @click="deleteItem(element)">
                                        <i class="fas fa-trash-alt "></i>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm8 v-if="element.isDeleteRow" class="delete_box">
                            <v-layout row wrap>
                                <v-flex xs8 class="delete_box__title">
                                    {{communityCommonConstant.filesAndMedia.DELETE_CONFIRMATION}}
                                </v-flex>
                                <v-flex xs12 sm4 text-xs-right class="delete_box__btns">
                                    <v-btn class="primary_btn  small outline"
                                           :data-qe-id="`tour_video_${i}_delete_cancel`"
                                           :disabled="deleteInProgress"
                                           @click="deleteCancel(element)">
                                        {{appCommonConstants.NO}}
                                    </v-btn>
                                    <v-btn :loading="deleteInProgress"
                                           :data-qe-id="`tour_video_${i}_delete_confirm`"
                                           class="primary_btn small outline"
                                           @click="deleteDetails(element)">
                                        {{appCommonConstants.YES}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs10 sm2 v-if="!element.isEditRow && !element.isDeleteRow">
                            <strong> {{element.title}} </strong>
                        </v-flex>

                        <v-flex
                            xs12
                            sm3
                            v-if="!element.isEditRow && !element.isDeleteRow"
                            class="last-modified-by">
                            <v-list-tile>
                                <v-list-tile-avatar>
                                    <img @error="imageErrorFallback(element)" :src="element.profileImageUrl">
                                </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        {{element.updatedUser}}
                                    </v-list-tile-content>
                            </v-list-tile>
                        </v-flex>
                        <v-flex xs4 v-if="!element.isEditRow && !element.isDeleteRow" sm2>
                            <strong> {{getShortDate(element.lastModifiedDateTime)}} </strong>
                        </v-flex>
                        <v-flex
                            xs8
                            sm4
                            text-xs-right
                            v-if="!element.isEditRow && !element.isDeleteRow"
                            class="actionsBlock">
                            <v-flex>
                                <v-icon
                                    class="fas fa-eye"
                                    :title="communityCommonConstant.filesAndMedia.PREVIEW"
                                    v-if="!element.isFolder"
                                    :data-qe-id="`tour_video_${i}_preview_btn`"
                                    @click="previewFile(element,i)"></v-icon>
                                <v-icon
                                    v-if="!element.downloadInProgress && (!element.isFolder)"
                                    class="fas fa-download"
                                    loading="true"
                                    :data-qe-id="`tour_video_${i}_download_btn`"
                                    @click="downloadVideo(element)"
                                    :title="communityCommonConstant.filesAndMedia.DOWNLOAD"></v-icon>
                                <v-progress-circular
                                    class="download-progress-circle"
                                    v-else-if="element.downloadInProgress"
                                    indeterminate
                                    size="15"
                                    :width="2"></v-progress-circular>
                                <v-icon
                                    class="fas fa-link"
                                    v-if="!element.isFolder"
                                    :title="communityCommonConstant.filesAndMedia.COPYLINK_TOOLTIP"
                                    :data-qe-id="`tour_video_${i}_copy-link_btn`"
                                    @click="copyFileLink(`dv_share_link_${i}`)"></v-icon>
                                <v-icon
                                    class="far fa-paper-plane"
                                    v-if="!element.isFolder"
                                    :title="communityCommonConstant.filesAndMedia.SHARELINK_TOOLTIP"
                                    :data-qe-id="`tour_video_${i}_share-link_btn`"
                                    @click="copyFileLink(`dv_share_link_${i}`)"></v-icon>
                                <v-icon
                                    v-if="canEditTakeTourVideos"
                                    :data-qe-id="`tour_video_${i}_edit_btn`"
                                    @click="editGridRow(element)"
                                    class="fas fa-pencil-alt"
                                    :title="communityCommonConstant.filesAndMedia.EDIT"></v-icon>
                                <v-flex v-if="!element.isFolder">
                                    <div v-if="!element.isFolder" :id="`dv_share_link_${i}`" class="share-link">{{element.url}}</div>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-layout>
                            <v-flex
                                xs12
                                text-xs-center
                                pa-5
                                v-show="takeTourVideoData && takeTourVideoData.length === 0">
                                <span>{{communityCommonConstant.filesAndMedia.NO_MEDIA}}</span>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </draggable>
                <v-layout>
                    <v-flex
                        xs12
                        text-xs-center
                        pa-5
                        v-show="takeTourVideoData && takeTourVideoData.length === 0">
                        <span>{{communityCommonConstant.filesAndMedia.NO_MEDIA}}</span>
                    </v-flex>
                </v-layout>

            </v-flex>
            <a :href="downloadFileUrl" download hidden ref="download"></a>
        </v-flex>
        <v-dialog
            v-model="isvalidateActionDialog"
            lazy
            absolute
            content-class="post-actions"
            persistent>
            <v-card>
                <v-flex tag="h6">{{confirmationTitle}}
                    <v-btn icon data-qe-id="close_dialog_btn" @click="cancelDialog()">
                            <v-icon size="20">{{ManageVideosConstants.CLOSE}}</v-icon>
                        </v-btn>
                </v-flex>
                <v-flex tag="p" data-qe-id="validation_dialog_message">
                    {{validationDialogMessage}}
                </v-flex>
                <v-flex text-xs-right>
                    <v-btn class="primary_btn transparent small"
                           data-qe-id="cancel_dialog_btn"
                           @click="cancelDialog()">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn class="primary_btn small"
                               data-qe-id="save_dialog_btn"
                               @click="confirmToSave()">
                            {{appCommonConstants.CONFIRM}}
                        </v-btn>
                </v-flex>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="openVideo.openVideoCarousel" content-class="medium">
            <video-carousel
                v-if="openVideo.openVideoCarousel"
                :open-video="openVideo"
                :take-tour-videos="takeTourVideos"
                :take-tour-preview-video="takeTourPreviewVideo"
                :take-tour-title="takeTourTitle"></video-carousel>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { appCommonConstants, routerNames } from "../appCommon.constants";
    import { communityCommonConstant, calculateFileSize } from "../ChapterPage/communityCommon.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import FileUpload from "vue-upload-component";
    import { getShortDate } from "@/common/utils/dateTime";
    import orderBy from "lodash/orderBy";
    import UploadVideos from "./FileDragDropArea";
    import draggable from 'vuedraggable';
    import { ManageVideosConstants, iconClassNames } from "../AssistPage/AssistPageConstants.js";
    import VideoCarousel from "../AssistPage/VideoCarousel";
    import { myToolsConstants } from "../Tools/mytools.constant";


    export default {
        name: "ManageVideos",
        components: {
            FileUpload,
            UploadVideos,
            draggable,
            VideoCarousel,
        },
        props: {
            canEdit: {
                type: Boolean,
                required: true,
            },
        },
        created() {
            this.validationDialogMessage = this.communityCommonConstant.filesAndMedia.DATA_SAVE_CONF_MESSAGE;
            this.takeTourVideoData = this.takeTourVideos;
            this.home();
        },
        watch: {
            takeTourVideos(videos) {
                this.takeTourVideoData = [...videos];
                this.orderMediaBy(this.sortKey, false);
                this.updateFileElementQuery();
            },

        },
        data: () => ({
            openVideo: {
                openVideoCarousel: false,
            },
            takeTourVideoData: [],
            takeTourPreviewVideo: [],
            ManageVideosConstants,
            confirmationTitle: '',
            communityCommonConstant,
            appCommonConstants,
            routerNames,
            currentRootOriginalOrder: [],
            validationDialogMessage: '',
            isReordered: false,
            downloadFileUrl: '',
            shareLinkCopiedMessage: '',
            deleteInProgress: false,
            saveInProgress: false,
            updateInProgress: false,
            manageVideosError: false,
            isEditError: false,
            isSaveError: false,
            isErrorMessage: '',
            nameAsc: true,
            typeAsc: true,
            dateAsc: true,
            modifiedByAsc: true,
            sortKey: "lastModifiedDateTime",
            isAddFolder: true,
            isCloseDialog: false,
            isDeleteRow: false,
            //communityName: "",
            isError: false,
            sortSettingsArray: [],
            asc: false,
            isEditName: "",
            editNameExtesion: "",
            canNavigateUp: false,
            parentName: "",
            currentRoot: null,
            isShowFilesContainer: false,
            isvalidateActionDialog: false,
            isExistItemName: "",

        }),
        methods: {
            ...mapActions({
                saveTourReorderList: `assistPage/${storeAction.saveTourReorderList}`,
                updateTakeTourVideoTitle: `assistPage/${storeAction.updateTakeTourVideoTitle}`,
                deleteTakeTourVideo: `assistPage/${storeAction.deleteTakeTourVideo}`,
                downloadTakeTourVideo: `assistPage/${storeAction.downloadTakeTourVideo}`,
            }),
            imageErrorFallback(element) {
                element.profileImageUrl = element.fallbackProfileImageUrl;
                return `this.src='${element.fallbackProfileImageUrl || ''}';this.onerror=null;`;
            },
            home() {
                this.takeTourVideoData = this.takeTourVideos;
                const retval = this.validateActions(this.communityCommonConstant.filesAndMedia.ACTIONS.EDIT);
                if (retval) {
                    this.currentRoot = null;
                    this.canNavigateUp = false;
                    this.updateFileElementQuery();
                }
            },
            changeOrder() {
                if (this.isReordered) {
                    this.takeTourVideoData.forEach((element, index) => {
                        element.order = index + 1;
                    });
                }
            },
            onListItemMove() {
                this.isReordered = true;
            },
            cancelOrder() {
                this.takeTourVideoData.forEach((ele) => {
                    ele.order = this.currentRootOriginalOrder.find(item => item.id === ele.id).order;
                });
                this.takeTourVideoData = orderBy(this.takeTourVideoData, 'order', "asc");
                this.isReordered = false;
            },
            saveOrder() {
                this.isReordered = false;
                this.saveTourReorderList(this.takeTourVideoData).then(() => {
                    this.$emit("bind");
                });
            },
            previewFile(taketour, index) {
                this.takeTourTitle = taketour.title;
                this.openVideo.openVideoCarousel = true;
                this.takeTourPreviewVideo = [];
                this.takeTourPreviewVideo.push(taketour);
                const tourLength = this.takeTourVideos.length - 1;
                if (tourLength > index) {
                    for (let i = index + 1; i <= tourLength; i += 1) {
                        this.takeTourPreviewVideo.push(this.takeTourVideos[i]);
                    }
                }
                for (let i = 0; i < index; i += 1) {
                    this.takeTourPreviewVideo.push(this.takeTourVideos[i]);
                }
            },
            copyFileLink(linkContainerId) {
                const range = document.createRange();
                range.selectNode(document.getElementById(linkContainerId));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                setTimeout(() => { document.execCommand("copy"); }, 0);
                this.shareLinkCopiedMessage = this.communityCommonConstant.filesAndMedia.LINK_COPIED_MESSAGE;
                setTimeout(() => { this.shareLinkCopiedMessage = ''; }, 2000);
            },
            getFileSize(isFolder, sizeInBytes, id) {
                if (isFolder) {
                    sizeInBytes = this.takeTourVideos.filter(f => f.parentId === id).reduce((sum, f) => {
                        return sum + f.fileSize;
                    }, 0);
                }
                return this.calculateFileSize(sizeInBytes, this.communityCommonConstant.filesAndMedia);
            },
            calculateFileSize,
            //end

            //Update Folder names
            editGridRow(itemofRow) {
                this.isExistItemName = itemofRow.title;
                const retval = this.validateActions(this.communityCommonConstant.filesAndMedia.ACTIONS.EDIT);
                if (retval) {
                    const fileName = this.takeTourVideoData.find(item => item.id === itemofRow.id).title;
                    if (fileName.lastIndexOf(".") > 0) {
                        this.isEditName = fileName.substring(0, fileName.lastIndexOf("."));
                        this.editNameExtesion = fileName.substring(fileName.lastIndexOf("."), fileName.length);
                    } else {
                        this.isEditName = fileName;
                        this.editNameExtesion = '';
                    }
                    this.takeTourVideoData.find(item => item.id === itemofRow.id).isEditRow = true;
                    this.takeTourVideoData = [...this.takeTourVideoData];
                }
            },
            async updateDetails(element) {
                if (this.isEditName !== "" && !this.manageVideosError) {
                    element.isEditRow = true;
                    element.isDeleteRow = false;
                    const obj = {};
                    obj.title = this.isEditName;
                    obj.id = element.id;

                    this.updateInProgress = true;
                    await this.updateTakeTourVideoTitle(obj);
                    this.updateInProgress = false;
                    element.isEditRow = false;
                    this.takeTourVideoData = [...this.takeTourVideoData];
                } else {
                    return false;
                }
            },
            //end
            cancelDialog() {
                this.isvalidateActionDialog = false;
            },
            orderMediaBy(sorKey, asc) {
                const retval = this.validateActions(this.communityCommonConstant.filesAndMedia.ACTIONS.REORDER);
                if (retval) {
                    this.sortKey = sorKey;
                    this.takeTourVideoData = orderBy(this.takeTourVideoData, this.sortKey, asc ? "asc" : "desc");

                    if (this.sortKey === this.communityCommonConstant.filesAndMedia.tableColumns.TYPE.value) {
                        this.typeAsc = !asc;
                    }
                    if (this.sortKey === this.communityCommonConstant.filesAndMedia.tableColumns.NAME.value) {
                        this.nameAsc = !asc;
                    }
                    if (this.sortKey === this.communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.value) {
                        this.dateAsc = !asc;
                    }
                    if (this.sortKey === this.communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.value) {
                        this.modifiedByAsc = !asc;
                    }

                    this.asc = !asc;
                }
            },
            getShortDate,
            closeFilesDialog() {
                this.isCloseDialog = true;
                if (this.validateActions(this.communityCommonConstant.filesAndMedia.ACTIONS.CLOSE)) {
                    this.isShowFilesContainer = false;
                    this.$emit("close");
                }
            },
            closeFilesDragDropArea() {
                this.isShowFilesContainer = false;
            },
            deleteItem(element) {
                const retval = this.validateActions(this.communityCommonConstant.filesAndMedia.ACTIONS.DELETE);
                if (retval) {
                    element.isEditRow = false;
                    element.isDeleteRow = true;
                    this.takeTourVideoData = [...this.takeTourVideoData];
                    this.isDeleteRow = true;
                    this.isCloseDialog = false;
                    this.isvalidateActionDialog = false;
                }
            },
            updateFileElementQuery() {
                this.takeTourVideoData = [...this.takeTourVideos];
                this.takeTourVideoData = orderBy(this.takeTourVideoData, 'order', "asc");
                this.currentRootOriginalOrder = this.takeTourVideoData.map(a => Object.assign({}, a));
            },
            displayFilesLayout() {
                this.isShowFilesContainer = true;
            },
            iconClassNames,
            confirmToSave() {
                this.isvalidateActionDialog = false;
                if (this.isReordered) {
                    this.saveOrder();
                    if (this.isCloseDialog) {
                        this.isShowFilesContainer = false;
                        this.$emit("close");
                    }
                } else {
                    const isEditRow = this.takeTourVideoData.find(o => o.isEditRow === true);
                    const isNewRow = this.takeTourVideoData.find(o => o.isNewRow === true);
                    const isDeleteRow = this.takeTourVideoData.find(o => o.isDeleteRow === true);
                    if (isEditRow) {
                        this.updateDetails(isEditRow);
                    } else if (isNewRow) {
                        //this.saveFolder(isNewRow);
                    } else if (this.isDeleteRow) {
                        this.deleteDetails(isDeleteRow);
                    }
                    if (this.isCloseDialog) {
                        this.isShowFilesContainer = false;
                        this.$emit("close");
                    }
                }
            },
            cancelDetails(itemofRow) {
                this.manageVideosError = false;
                this.takeTourVideoData.find(item => item.id === itemofRow.id).isEditRow = false;
                this.takeTourVideoData = [...this.takeTourVideoData];
            },
            duplicateName(fieldName, type, isFolder) {
                if (fieldName) {
                    this.manageVideosError = false;
                    this.isEditError = false;
                    this.isSaveError = false;
                    this.isErrorMessage = '';
                    if (fieldName.length > 0) {
                        let count;
                        if (isFolder) {
                            count = this.takeTourVideoData.filter(item => item.title.toLowerCase().trim() === fieldName.toLowerCase().trim()).length;
                        } else {
                            count = this.takeTourVideoData.filter(item => item.title.substring(0, item.title.lastIndexOf(".")).toLowerCase().trim() === fieldName.toLowerCase().trim()).length;
                        }
                        if (type === appCommonConstants.UPDATE && count > 0) {
                            if (this.isExistItemName.toLowerCase().trim() !== (fieldName + this.editNameExtesion).toLowerCase().trim()) {
                                this.manageVideosError = true;
                                return false;
                            }
                        } else if (type === appCommonConstants.SAVE && count > 1) {
                            this.manageVideosError = true;
                            return false;
                        }
                        this.manageVideosError = false;
                    }
                }
            },
            async deleteDetails(element) {
                this.deleteInProgress = true;
                await this.deleteTakeTourVideo(element.id);
                this.takeTourVideoData = [...this.takeTourVideoData];
                this.deleteInProgress = false;
            },
            deleteCancel(element) {
                element.isDeleteRow = false;
                element.isEditRow = true;
                this.takeTourVideoData = [...this.takeTourVideoData];
            },
            isValidFolderName($event, FolderName) {
                if ($event.charCode === 0 ||
                    ($event.charCode >= 48 && $event.charCode <= 57) ||
                    ($event.charCode >= 65 && $event.charCode <= 90) ||
                    ($event.charCode >= 97 && $event.charCode <= 122) ||
                    $event.charCode === 95 ||
                    $event.charCode === 32) {
                    return true;
                }
                if (FolderName.length >= 64) {
                    $event.preventDefault();
                    return true;
                }
                $event.preventDefault();
            },

            validateActions(typeofaction) {
                let isValid = true;
                this.isvalidateActionDialog = false;
                const isEdit = this.takeTourVideoData.find(e => e.isEditRow === true);
                const isDelete = this.takeTourVideoData.find(e => e.isDeleteRow === true);
                if (isDelete) {
                    this.isDeleteRow = true;
                }
                if (this.isReordered || isDelete || (isEdit && typeofaction !== this.communityCommonConstant.filesAndMedia.ACTIONS.DELETE) || (isEdit && (this.isEditName + this.editNameExtesion) !== isEdit.title)) {
                    isValid = false;
                    this.isvalidateActionDialog = true;
                    if (isEdit) {
                        this.confirmationTitle = communityCommonConstant.filesAndMedia.UPDATE;
                    } else if (isDelete) {
                        this.confirmationTitle = communityCommonConstant.filesAndMedia.DELETE;
                    } else if (this.isReordered) {
                        this.confirmationTitle = communityCommonConstant.filesAndMedia.REORDER;
                    }
                    this.validationDialogMessage = communityCommonConstant.filesAndMedia.DATA_SAVE_CONF_MESSAGE;
                }
                return isValid;
            },

            downloadVideo(video) {
                this.takeTourVideoData.find(vid => vid.id === video.id).downloadInProgress = true;
                this.takeTourVideoData = [...this.takeTourVideoData];
                this.downloadTakeTourVideo(video).then(() => {
                    this.takeTourVideoData.find(vid => vid.id === video.id).downloadInProgress = false;
                    this.takeTourVideoData = [...this.takeTourVideoData];
                });
            },
        },
        computed: {
            ...mapGetters({
                takeTourVideos: `assistPage/${storeGetters.takeTourVideos}`,
                canEditTakeTourVideos: `assistPage/${storeGetters.canEditTakeTourVideos}`,
            }),
            isVisible() {
                if (this.isAllNetworks) {
                    return this.canEditTakeTourVideos;
                }
                return true;
            },
            isAllNetworks() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.title.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE);
            },
            isRowEditingOrCreating() {
                return this.takeTourVideoData.filter((ele) => {
                    return (ele.isEditRow);
                }).length > 0;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .manage-videos-popup {
        background: $white;
        position: relative;
        overflow: hidden;
        min-height: 90vh;

        &__header {
            background: $ypo-blue;
            padding: 50px 0 20px 30px;
            position: relative;

            h3 {
                font-size: 36px;
                font-family: 'Raleway', sans-serif;
                color: $white;
                font-weight: 200;
                letter-spacing: -0.74px;
                line-height: 56px;

                small {
                    display: block;
                    color: $white;
                    font-family: 'Noto Sans', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 2.41px;
                    line-height: 16px;
                    text-transform: uppercase;
                    margin-top: 3px;
                }

                .welcome {
                    display: block;
                    color: $white;
                    font-family: 'Noto Sans', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 2.41px;
                    line-height: 16px;
                    margin-top: 3px;
                    padding-left: 5px;
                }
            }

            .close-btn {
                position: absolute;
                right: 0;
                top: 0;
                color: $white;

                i {
                    font-size: 20px;
                    font-weight: 600;
                }
            }
        }

        .v-list__tile {
            padding: 0;
        }

        &__icons {
            text-align: right;
            padding: 20px 0;

            .v-icon {
                color: $ypo-cta !important;
                margin: 0 14px;
                font-size: 20px;
            }
        }

        &__breadcrumb {
            padding: 20px 20px;
            color: $ypo-cta;
            font-size: 16px;
            font-weight: bold;

            .content_header {
                font-size: 20px;
                font-family: 'Raleway', sans-serif;
                color: $ypo-blue;
                font-weight: 500;
                letter-spacing: -0.74px;
                padding-left: 13px;
            }

            .fa-home {
                margin: 0 10px 0 0;
                font-size: 20px;
            }

            strong {
                margin-left: 10px;
                color: $ypo_blue;

                i {
                    margin-right: 10px;
                }
            }
        }

        .headding {
            background: $ypo-blue;
            padding: 10px;
            color: $ypo-dark-gray;
            font-size: 14px;
            font-weight: bold;
            line-height: 24px;

            a {
                position: relative;
                color: $white;

                .fas {
                    font-size: 20px;
                    color: $white;

                    &.fa-sort-down {
                        position: relative;
                        left: 3px;
                        top: -2px;
                    }

                    &.fa-sort-up {
                        position: relative;
                        top: 7px;
                        left: 3px;
                    }
                }
            }
        }

        .dragDiv {
            margin: 15px 10px;
            padding: 10px;
            align-items: center;
            box-shadow: 0 2px 4px 0 rgba($black, 0.5);

            &.cursor-move {
                cursor: move;
            }

            strong {
                word-break: break-word;
            }
        }

        .typeBlock {
            span {
                color: $ypo-dark-background-gray;
                font-size: 9px;
                font-weight: bold;
                letter-spacing: 0.59px;
                line-height: 12px;
                display: block;
                text-transform: uppercase;
            }

            i {
                color: $ypo-cta;
                margin: 5px 0;
            }
        }

        .nameBlock {
            strong {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0.19px;
                line-height: 26px;
                word-break: break-all;

                &.pointer {
                    &:hover {
                        color: $ypo-cta;
                    }
                }
            }
        }

        .actionsBlock {
            .v-icon {
                font-size: 16px;
                color: $ypo-cta !important;
                margin: 0 10px;
                cursor: pointer;

                &:hover {
                    color: $ypo_blue !important;
                }
            }
        }

        .inputBlock {
            background: $ypo-dark-background-gray;
            padding: 10px 10px;

            input {
                width: 100%;
                min-height: 40px;
                color: $white;
                border-bottom: 1px solid $white;
                top: 0;

                &:focus {
                    outline: none;
                }
            }
        }

        .btns_div {
            .v-btn {
                margin: 15px 3px;
            }
        }

        .delete_box {
            background: $ypo_blue;
            flex: auto;
            margin: -10px;
            max-width: inherit;
            padding: 10px 30px 10px 10px;

            &__title {
                color: $white;
                padding: 10px 0 0 50px;
                align-items: center;
            }

            &__btns {
                .v-btn {
                    border: 1px solid $white;
                    font-weight: 500;
                }
            }
        }
        @include breakpoint(xs) {

                &__header {
                    padding: 5px 0 20px 30px;

                    h3 {
                        font-size: 24px;
                    }
                }
                &__breadcrumb {
                    .content_header {
                        font-size: 14px;
                    }
                }
                .typeBlock i {
                    font-size: 24px !important;
                }
                .delete_box {
                    padding: 10px;
                    width: 100%;
                    margin: 5px 0 0 0;
                    &__title {
                        padding: 0px;
                    }
                }

                .last-modified-by {
                    border-top: 1px dashed $ypo-medium-gray;
                    border-bottom: 1px dashed $ypo-medium-gray;
                    margin: 10px 0;
                    padding: 5px 0;
                }

                .nameBlock strong {
                    font-size: 12px;
                }
                .share-link {
                    &-copied-message {
                        font-size: 12px;
                        padding: 0px 5px;
                    }
                }
        }
    }

    .error-msg {
        color: $ypo-error-red;
        position: relative;
        left: 25px;
        top: 20px;
    }

    .last-modified-by {
        color: $ypo_blue;
    }

    .download-progress-circle {
        margin: 1rem;
        color: $ypo_blue;
    }

    .share-link {
        opacity: 0;
        font-size: 0;

        &-copied-message {
            font-size: 16px;
            text-align: center;
            padding: 3px 30px;
            color: $ypo-cta;
        }


    }
</style>
